import React from 'react'
import Headtitle from "../../Components/HeadTitle/Headtitle"
import All_Item from './All_Item';
import "../Destination/Destination.scss";




function Destination() {
  return (
    <div>
    <Headtitle/>
    &nbsp;
    <All_Item/>
    </div>
  )
}

export default Destination;